/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Product_Id_LabelInputs */

const en_admin_payments_product_id_label = /** @type {(inputs: Admin_Payments_Product_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product ID`)
};

const zh_admin_payments_product_id_label = /** @type {(inputs: Admin_Payments_Product_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品 ID`)
};

/**
* | output |
* | --- |
* | "Product ID" |
*
* @param {Admin_Payments_Product_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_product_id_label = /** @type {((inputs?: Admin_Payments_Product_Id_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Product_Id_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_product_id_label(inputs)
	return zh_admin_payments_product_id_label(inputs)
});
export { admin_payments_product_id_label as "admin.payments.product_id_label" }